export const fetchPath = (src: string) => {
  let pathName = src;
  try {
    pathName = new URL(src).pathname;
    return pathName;
  } catch (e) {}

  return src;
};
